<script>
  import { fade } from 'svelte/transition';
  import { ConfigStore } from '../../../../lib/store/config';
</script>

<div class="cs-search-loading-with-text" transition:fade|global>
  <span
    class="cs-search-loading-text"
    style:background={$ConfigStore.customTheme.msgBubbleAgentBg}
    style:color={$ConfigStore.customTheme.msgBubbleAgentTextColor}
    >{$ConfigStore.customTheme?.loadingTextThemeType}</span
  >
  <div id="dots">
    <div class="snippet" data-title="dot-flashing">
      <div class="stage">
        <div class="dot-flashing"></div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @use './../../../../scss/components/themes/loading-theme/loading-with-text-theme';
</style>
